
import './YehsGroup.module.scss';
import React, { useState, useEffect, useMemo } from 'react';
import { TableList } from "../../../components";
import common from '../../../common';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function YehsGroup({ cateIdx, type }) {

    const { useAlert, useLoading } = common();
    const { pAlert, AlertComponent } = useAlert();
    const { pLoadingOn, pLoadingOff, LoadingComponent } = useLoading();
    const [data, setData] = useState([]);

    const tableLoadData = {
        tableType: 'YehsGroup',
        type: type,
        cate: [cateIdx]
    };


    const fetchData = async () => {
        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/yehs_document/out/get_table`, tableLoadData , {
                withCredentials: true
            });

            if (response.data.result === 't') {
                const data = response.data.data;
                setData(data);
            } else {
                pAlert(response.data.msg);
            }
        } catch (error) {
            console.error('Data fetching failed:', error);
        } finally {
            pLoadingOff();
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    const columns = useMemo(() => [
        { title: '제목', dataIndex: 'title', className: 'text_start' },
        { title: '등록일', dataIndex: 'createTime', className: '' },
        { title: '작성자', dataIndex: 'member', className: '' },
        { title: '추천수', dataIndex: 'likeCount', className: '' },
    ], []);

    const pageSize = 10;
    const categoryOptions = useMemo(() => [
        { label: '전체', value: '전체' },
        { label: '제목', value: 'title' },
        { label: '내용', value: 'contents' },
        { label: '작성자', value: 'member' },
    ], []);

    const handleRowClick = () => {
        window.location.href = `/board?cateIdx=`+cateIdx+`&boardType=new`;
    };


    return (
        <>
            <div className="components_wrap">
                <span className='components_wrap_title'>YEHS 소모임</span>
                <TableList data={data} columns={columns} pageSize={pageSize} categoryOptions={categoryOptions} type={"Editor"}/>
                <div className="editor_regist_btn_box">
                    <button 
                        className='editor_regist_btn'
                        onClick={handleRowClick}    
                    >글쓰기</button>
                </div>
            </div>
        </>
    );
}

export default YehsGroup;